<template>
    <b-container>
        <b-row v-if="gelen.hataVarMi">
            {{gelen.mesaj }}
        </b-row>
        <div v-else>
            <b-row class="my-3">
                <b-col lg="6" class="my-1">
                    <b-form-group
                            label="Arama"
                            label-cols-sm="2"
                            label-align-sm="left"
                            label-size="sm"
                            label-for="filterInput"
                            class="mb-0"
                    >
                        <b-input-group size="sm">
                            <b-form-input
                                    v-model.trim="filter"
                                    type="search"
                                    id="filterInput"
                                    placeholder="Arama"
                                    @input="aramaChange"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col lg="6" align="end" class="p-0">
                    <b-button variant="info" @click="excelOlustur">Excel Oluştur</b-button>
                    <b-button class="ml-3" variant="success" @click="yeniKisiClick">Yeni Kişi Ekle</b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-table
                            show-empty
                            small
                            striped
                            hover
                            stacked="md"
                            empty-text="Kayıt Bulunamadı"
                            select-mode="single"
                            :selectable="true"
                            :items="items"
                            :fields="fields"
                            :filter="filter"
                            :per-page="0"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                    >

                        <template v-slot:cell(eposta)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.eposta"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>

                        <template v-slot:cell(yonetici)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.yonetici === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>
                        <template v-slot:cell(mektupEditor)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.mektupEditor === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>
                        <template v-slot:cell(mektupOperator)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.mektupOperator === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>

                        <template v-slot:cell(kartEditor)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.kartEditor === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>
                        <template v-slot:cell(kartOperator)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.kartOperator === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>
                        
                        <template v-slot:cell(bayanMi)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.bayanMi === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>
                        <template v-slot:cell(aktif)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.aktif === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>
                        <template v-slot:cell(telegram)="row">
                            <b-icon-check font-scale="2" variant="success" v-if="row.item.telegram === true"/>
                            <b-icon-x font-scale="2" variant="danger" v-else/>
                        </template>


                        <template v-slot:cell(operatorMektupSayi)="row">
                            <a href="#" @click="BelgelereGit('mektup',row.item.kisiId)"> {{row.item.operatorMektupSayi}}</a>
                        </template>

                        <template v-slot:cell(operatorKartSayi)="row">
                            <a href="#" @click="BelgelereGit('kart',row.item.kisiId)"> {{row.item.operatorKartSayi}}</a>
                        </template>
                        

                    </b-table>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
    import {
        KarttaHicVazifeYapmayanKisileriGeti,
        KarttaHicVazifeYapmayanKisileriGetir,
        KisilerExcelOlustur,
        TumKisiler
    } from "@/api/kisi"
    import {GoogleTokenIleGirisYapmayiDene} from "@/utils/googlegiris";
    import moment from "moment";
    import {mapGetters} from "vuex";
    import {KisiFiltre} from "@/utils/kisiFiltre";

    export default {
        
        computed: {
            ...mapGetters([
                'bkCount', 'kisi', 'girisYapmismi'
            ])
        },
        data() {
            return {
                gelen: {
                    hataVarMi: true,
                    mesaj: "Yükleniyor"
                },
                items: [],
                filter: null,
                sortBy: 'isim',
                sortDesc: false,
                fields: [
                    {key: 'isim', label: 'İsim', sortable: true},
                    {key: 'eposta', label: 'Eposta', sortable: true},
                    {key: 'bayanMi', label: 'Kadın', sortable: true},
                    {key: 'aktif', label: 'Aktif', sortable: true},
                    {key: 'yonetici', label: 'Yönetici', sortable: true},
                    {key: 'mektupEditor', label: 'Mektup Editör', sortable: true},
                    {key: 'mektupOperator', label: 'Mektup Operator', sortable: true},

                    {key: 'kartEditor', label: 'Kart Editör', sortable: true},
                    {key: 'kartOperator', label: 'Kart Operator', sortable: true},
                    
                    {key: 'telegram', label: 'Telegram', sortable: true},
                    
                    {key: 'editorMektupSayi', label: 'Mektup Tashih', sortable: true},
                    {key: 'operatorMektupSayi', label: 'Mektup', sortable: true},
                    {key: 'editorKartSayi', label: 'Kart Tashih', sortable: true},
                    {key: 'operatorKartSayi', label: 'Kart', sortable: true},
                    {key: 'toplam', label: 'Toplam', sortable: true},

                ],
            }
        },
        methods: {
            async excelOlustur() {
                window.open('https://latinize.kizilay.org.tr/api/kisi/KisilerExcelOlustur', '_blank'); 
            },
            async BelgelereGit(tur, id) {
                await this.$router.push('/belgeler?ne=sahsi&tur=' + tur + '&id=' + id);
            },
            async bismillah() {
                const that = this;
                if (!this.girisYapmismi) {
                    await new GoogleTokenIleGirisYapmayiDene(this);
                }

                if (!this.girisYapmismi) {
                    this.gelen.mesaj = "Giriş yapmanız lazım";
                    this.gelen.hataVarMi = true;

                    setTimeout(function () {
                        that.$router.push("/giris-yap?url=" + encodeURI("/mektup"))
                    }, 3000);
                    return
                }
            
                const filtre = this.$route.query.filtre
                if (filtre === undefined) {
                    this.gelen = await TumKisiler();
                    this.items = this.gelen.data;
                    return;
                }

                if (parseInt(filtre) === KisiFiltre.karttaHicYapmayanlar) {
                    this.gelen = await TumKisiler(true);
                    this.items = this.gelen.data;
                }
                else if (parseInt(filtre) == KisiFiltre.karttaDortHaftadirYapmayanlar) {
                    this.gelen = await TumKisiler(false, true);
                    this.items = this.gelen.data;
                }
            },
            rowSelected(items) {
                this.$router.push('kisi/' + items[0].kisiId)
            },
            aramaChange(text) {
                this.filter = text.toUpperCase()
            },
            yeniKisiClick() {
                this.$router.push('kisi/-1')
            }
        },
        async mounted() {
            this.bismillah();
        },
    }
</script>

<style scoped>

</style>
